import { render } from "./RemarksTab.vue?vue&type=template&id=a5d0e152&scoped=true&ts=true"
import script from "./RemarksTab.vue?vue&type=script&lang=ts"
export * from "./RemarksTab.vue?vue&type=script&lang=ts"

import "./RemarksTab.vue?vue&type=style&index=0&id=a5d0e152&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d0e152"]])

export default __exports__